<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="clip">
      <div class="clip__bg" data-move-standard data-move data-speed="5">
        <div class="clip__bg-view">
          <video
            v-show="!isReverse"
            id="video"
            src="https://vod.plaync.com/LineageW/4_PageTurn_a_f_0810.mp4"
            muted
            playsinline
          />
          <video
            v-show="isReverse"
            id="videoR"
            src="https://vod.plaync.com/LineageW/4_PageTurn_b_f_0810.mp4"
            muted
            playsinline
          />
        </div>
        <div class="clip__img">
          <img
            v-show="currentClip == 1"
            :style="'width:' + imgWidth + 'px'"
            :src="staticPath + '/img/clip_1.jpg'"
          />
          <img
            v-show="currentClip == 2"
            :style="'width:' + imgWidth + 'px'"
            :src="staticPath + '/img/clip_2.jpg'"
          />
          <img
            v-show="currentClip == 3"
            :style="'width:' + imgWidth + 'px'"
            :src="staticPath + '/img/clip_3.jpg'"
          />
          <img
            v-show="currentClip == 4"
            :style="'width:' + imgWidth + 'px'"
            :src="staticPath + '/img/clip_4.jpg'"
          />
          <img
            v-show="currentClip == 5"
            :style="'width:' + imgWidth + 'px'"
            :src="staticPath + '/img/clip_5.jpg'"
          />
        </div>
        <div class="clip__btn-con" :style="'width:' + imgWidth + 'px'">
          <ClipBtn
            v-show="currentClip == 1"
            @click.native="playClip('1')"
            class="clip__btn clip__btn--1"
            :idx="1"
            :isView="currentClip == 1"
            >play</ClipBtn
          >
          <ClipBtn
            v-show="currentClip == 2"
            @click.native="playClip('2')"
            class="clip__btn clip__btn--2"
            :idx="2"
            :isView="currentClip == 2"
            >play</ClipBtn
          >
          <ClipBtn
            v-show="currentClip == 3"
            @click.native="playClip('3')"
            class="clip__btn clip__btn--3"
            :idx="3"
            :isView="currentClip == 3"
            >play</ClipBtn
          >
          <ClipBtn
            v-show="currentClip == 3"
            @click.native="playClip('4')"
            class="clip__btn clip__btn--4"
            :idx="4"
            :isView="currentClip == 3"
            >play</ClipBtn
          >
          <ClipBtn
            v-show="currentClip == 4"
            @click.native="playClip('5')"
            class="clip__btn clip__btn--5"
            :idx="5"
            :isView="currentClip == 4"
            >play</ClipBtn
          >
          <ClipBtn
            v-show="currentClip == 5"
            @click.native="playClip('6')"
            class="clip__btn clip__btn--6"
            :idx="6"
            :isView="currentClip == 5"
            >play</ClipBtn
          >
        </div>
      </div>

      <FrameBook></FrameBook>
      <div class="clip__menu">
        <div class="clip__menu-con">
          <!--          <router-link :to="{name: 'clip', query:{page:'1'}}" v-html="$t('menu.clip-sub.clip-1')"></router-link>-->
          <!--          <router-link :to="{name: 'clip', query:{page:'2'}}" v-html="$t('menu.clip-sub.clip-2')"></router-link>-->
          <!--          <router-link :to="{name: 'clip', query:{page:'3'}}" v-html="$t('menu.clip-sub.clip-3')"></router-link>-->
          <button
            class="clip__menu-btn--1"
            @click="clipMenuClick(1)"
            v-html="$t('menu.clip-sub.clip-1')"
          ></button>
          <button
            class="clip__menu-btn--2"
            @click="clipMenuClick(2)"
            v-html="$t('menu.clip-sub.clip-2')"
          ></button>
          <button
            class="clip__menu-btn--3"
            @click="clipMenuClick(3)"
            v-html="$t('menu.clip-sub.clip-3')"
          ></button>
          <button
            class="clip__menu-btn--4"
            @click="clipMenuClick(4)"
            v-html="$t('menu.clip-sub.clip-3')"
          ></button>
          <button
            class="clip__menu-btn--5"
            @click="clipMenuClick(5)"
            v-html="$t('menu.clip-sub.clip-3')"
          ></button>
        </div>
      </div>
      <ScrollBtn></ScrollBtn>
    </section>
  </transition>
</template>

<script>
import BaseSection from "./mixins/BaseSection.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import ScrollBtn from "../components/ScrollBtn";
import ClipBtn from "../components/ClipBtn";

export default {
  name: "clip",
  components: { FrameBook, ScrollBtn, ClipBtn},
  mixins: [BaseSection],
  data() {
    return {
      name: "clip",
      clipVideo: null,
      clipVideoR: null,
      currentClip: 0,
      nextClip: 0,
      clipTime: [0, 1.5, 2.5, 3.3, 4.2, 5],
      clipTimeR: [4, 3.4, 2.6, 1.8, 0.8, 0],
      playSeed: 1,
      isReverse: false,
      timer: null,
      clipImgCon: null,
      clipBtnCon: null,
      imgWidth: 1920,
      clipImgClassName: "",
      titMotion: null,
      clipMenus: [],
      bg: "",
      clipLayerData: {
        1: {
          clipId: "1",
          video: "https://vod.plaync.com/LineageW/03_1_Eternally_f_0810.mp4",
          youtube: {
            ko: "IwVPmm-RKqQ",
            en: "EGql7OgWzzE",
            ja: "lz7QfEu0h-s",
            zh: "p_nTmA0o8QA",
          },
          coming: false,
          tit: `${this.$t("clip.1.tit")}`,
          desc: `${this.$t("clip.1.desc")}`,
        },
        2: {
          clipId: "2",
          video: "https://vod.plaync.com/LineageW/03_2_bloodtree_f_0810.mp4",
          youtube: "",
          coming: false,
          tit: `${this.$t("clip.2.tit")}`,
          desc: `${this.$t("clip.2.desc")}`,
          story: `${this.$t("clip.2.story")}`,
        },
        3: {
          clipId: "3",
          video: "https://vod.plaync.com/LineageW/03_3_5guardians_f_0810.mp4",
          youtube: "",
          coming: false,
          tit: `${this.$t("clip.3.tit")}`,
          desc: `${this.$t("clip.3.desc")}`,
          story: `${this.$t("clip.3.story-1")}`,
        },
        4: {
          clipId: "3",
          video:
            "https://vod.plaync.com/LineageW/03_3_Enchant_Guide_f_0810.mp4",
          youtube: "",
          coming: false,
          tit: `${this.$t("clip.3.tit")}`,
          desc: `${this.$t("clip.3.desc")}`,
          story: `${this.$t("clip.3.story-2")}`,
        },
        5: {
          clipId: "4",
          video: "https://vod.plaync.com/LineageW/03_4_castlesiege_f_0810.mp4",
          youtube: "",
          coming: false,
          tit: `${this.$t("clip.4.tit")}`,
          desc: `${this.$t("clip.4.desc")}`,
          story: `${this.$t("clip.4.story")}`,
        },
        6: {
          clipId: "5",
          video: "https://vod.plaync.com/LineageW/03_5_Shortclip5_f_0810.mp4",
          youtube: {
            ko: "4AOxIDAGGdk",
            en: "V0XpsKAsYfU",
            ja: "WDxcGxmRIXI",
            zh: "l7WnTh8NYZk",
          },
          coming: false,
          tit: `${this.$t("clip.5.tit")}`,
          desc: `${this.$t("clip.5.desc")}`,
        },
      },
    };
  },
  methods: {
    ...mapMutations(["setClipQuery"]),
    setMotion() {
      const startTime = this.currentPage == "index" ? 0.01 : 0.5;
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, startTime, { opacity: 0, ease: "power2.easeOut" });

      this.titMotion = new gsap.timeline({ paused: true });
      this.titMotion
        .addLabel("title", "+=1")
        .fromTo(
          this.$el.querySelector(`.${this.name}__menu`),
          0.5,
          { autoAlpha: 0 },
          { autoAlpha: 1, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.scroll-btn`),
          0.5,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.2"
        );
    },
    pageMove(num) {
      this.setIsMovePage(true);
      this.nextClip = num;
      const distance = this.nextClip - this.currentClip;
      if (distance > 0) {
        this.isReverse = false;
      } else {
        this.isReverse = true;
      }
      this.playVideo(distance);
    },
    playVideo(distance) {
      if (!this.isReverse) {
        this.clipVideo.playbackRate = 0.5 + Math.abs(distance) / 2;
        this.clipVideo.play();
        this.chechTime();
      } else {
        this.clipVideoR.playbackRate = 0.5 + Math.abs(distance) / 2;
        this.clipVideoR.play();
        // setTimeout(()=>{this.clipVideoR.play();},100 )
        this.chechTime();
      }
      gsap.to(this.clipImgCon, 0.1, { opacity: 0 });
      gsap.to(this.clipBtnCon, 0.1, { opacity: 0 });
    },
    async stopVideo(video) {
      this.currentClip = parseInt(this.nextClip);
      video.pause();
      await this.pageImgChange();
      this.imgWidth = video.offsetWidth;
    },
    pageImgChange() {
      gsap.to(this.clipImgCon, 0.3, {
        opacity: 1,
        onComplete: () => {
          this.setIsMovePage(false);
        },
      });
      gsap.to(this.clipBtnCon, 0.3, { opacity: 1 });
    },

    chechTime() {
      this.timer = setTimeout(() => {
        if (!this.isReverse) {
          if (this.clipTime[this.nextClip] <= this.clipVideo.currentTime) {
            this.clipVideoR.currentTime = this.clipTimeR[this.nextClip];
            this.stopVideo(this.clipVideo);
            clearTimeout(this.timer);
            return;
          }
        } else {
          if (this.clipTimeR[this.nextClip] <= this.clipVideoR.currentTime) {
            this.clipVideo.currentTime = this.clipTime[this.nextClip];

            this.stopVideo(this.clipVideoR);
            clearTimeout(this.timer);
            return;
          }
        }
        this.chechTime();
      }, 1);
    },

    playClip(num) {
      this.setSelectClip(this.clipLayerData[num]);
      this.setIsLayer(true);
      const className = "clip__img--" + num;
      this.clipImgClassName = className;
      gsap.to(this.clipImgCon, 0.5, {
        className: `+= ${className}`,
        ease: "power3.easeOut",
      });
      gsap.to(this.clipBtnCon, 0.2, { opacity: 0, ease: "power3.easeIn" });
    },

    stopClip() {
      gsap.to(this.clipImgCon, 0.5, {
        className: `-= ${this.clipImgClassName}`,
        ease: "power4.easeOut",
      });
      gsap.to(this.clipBtnCon, 0.3, {
        opacity: 1,
        ease: "power3.easeIn",
        delay: 0.5,
      });
    },

    clipMenuClick(page) {
      if (this.clipQuery == page) return;
      this.$router.push({ name: "clip", query: { page: page } });
    },

    start() {
      const startNum = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.pageMove(startNum);

      this.setClipQuery(startNum);

      $(this.clipMenus[startNum - 1]).addClass("router-link-exact-active");
      this.enterMotion.play();
      this.titMotion.play();
    },
    enter(el, done) {
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", () => {
        done();
      });
      if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);
    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
    },
  },
  mounted() {
    this.clipImgCon = document.querySelector(".clip__img");
    this.clipBtnCon = document.querySelector(".clip__btn-con");
    this.clipVideo = document.querySelector(".clip__bg-view #video");
    this.clipVideoR = document.querySelector(".clip__bg-view #videoR");
    this.clipVideoR.load();
    this.clipVideoCon = document.querySelector(".clip__video");
    this.clipMenus = document.querySelectorAll(".clip__menu-con button");
    this.$watch("clipQuery", (val) => {
      this.pageMove(val);
      $(this.clipMenus).removeClass("router-link-exact-active");
      $(this.clipMenus[val - 1]).addClass("router-link-exact-active");
    });
    this.$watch("selectClip", (val, old) => {
      if (old !== null) this.stopClip();
    });
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }

    this.bg = this.$el.querySelector(".clip__bg");
    this.$watch(
      "documentSize",
      (val) => {
        let w, h, left;
        // const r = val.h/val.w;
        // const rh = val.w/val.h;
        // if(val.h < val.w){
        //   if(r > 0.5625){
        //     h = val.h;
        //     w =   val.w*rh;
        //     left = (w-val.w)/2
        //   }else{
        //     w =   val.w * 1;
        //     h = w * 0.5625;
        //     left = val.w * 0.1
        //   };
        // }else{
        //   if(rh >= 0.5625){
        //     h = val.h;
        //     w =   val.h*r;
        //     left = (w-val.w)/2
        //   }else{
        //     h = val.h;
        //     w =   val.h*1.78;
        //     left = (w-val.w)/2
        //   };
        // }

        if (val.w > 1920) {
          w = val.w;
          left = 0;
        } else {
          w = 1920;
          left = (w - val.w) / 2;
        }
        this.bg.style.width = w + "px";
        //this.bg.style.height = h+'px';
        this.bg.style.left = -left + "px";

        this.imgWidth = this.clipVideo.offsetWidth;
      },
      { immediate: true }
    );
  },
  // beforeRouteUpdate(to, from, next) {
  //
  //   console.log(to, from)
  //   next({query:to.query})
  // }
};
</script>

<style lang="scss">
.clip {
  //@include bg($bg: '../assets/img/clip_guide.jpg');
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    //visibility: hidden;
    &-view {
      @include position($position: absolute, $top: 0, $left: 0, $width: 100%, $height: 100%);
      // @include bg($bg: '../img/clip_bg.png', $cover: cover);
      min-width: 1920px;
      overflow: hidden;
      video {
        position: absolute;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
        &.active {
          z-index: 1;
        }
      }
    }
  }
  &__img {
    @include position(
      $position: absolute,
      $top: 0,
      $left: 0,
      $width: 100%,
      $height: 100%
    );
    margin: 0;
    opacity: 0;
    z-index: 3;
    img {
      position: absolute;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 0;
    }
    &--1 {
      margin: 48.5% 0 0 85.5%;
      transform: scale(7.5);
    }
    &--2 {
      margin: 8% 0 0 43.5%;
      transform: scale(2.27);
    }
    &--3 {
      margin: 29% 0 0 86%;
      transform: scale(3.5);
    }
    &--4 {
      margin: 31% 0 0 -25%;
      transform: scale(3.5);
    }
    &--5 {
      margin: 33.2% 0 0 92%;
      transform: scale(4);
    }
    &--6 {
      margin: 20.5% 0 0 63%;
      transform: scale(2.4);
    }
  }
  &__btn {
    &--1 {
      margin: -5.7% 0 0 -10.5%;
    }
    &--2 {
      margin: -5% 0 0 -20%;
    }
    &--3 {
      margin: -8% 0 0 -24%;
    }
    &--4 {
      margin: -10% 0 0 9.7%;
    }
    &--5 {
      margin: -9% 0 0 -23%;
    }
    &--6 {
      margin: -9.5% 0 0 -26.5%;
    }
    &-con {
      position: absolute;
      height: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      opacity: 0;
    }
  }
  &__video {
    @include position(
      $position: absolute,
      $top: 0,
      $left: 0,
      $width: 100%,
      $height: 100%
    );
    display: none;
    opacity: 0;
    video {
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &-close {
      @include position($position: absolute, $top: 100px, $right: 100px);
      background: #ffff00;
      width: 100px;
      height: 100px;
      border-radius: 50%;
    }
  }
  &__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    width: 100%;
    height: 700px;
    //  background: #f0f;
  }

  &__menu {
    @include position(
      $position: absolute,
      $bottom: 20px,
      $left: 50%,
      $width: 1408px,
      $height: 284px
    );
    @include bg($bg: "../assets/img/clip_menu_bg.png");
    margin-left: -710px;
    background-size: 100% auto;
    z-index: 11;
    &-con {
      @include position(
        $position: absolute,
        $top: 131px,
        $left: 50%,
        $width: 1040px,
        $height: 93px
      );

      button {
        display: table-cell;

        @include position($width: 208px, $height: 93px);
        @include bg($bg: "../assets/img/ko/clip_menu.png", $position: 0 0);
        @include hide-text;
        &:after {
          @include position(
            $position: absolute,
            $top: 0,
            $left: 0,
            $width: 100%,
            $height: 100%
          );
          @include bg(
            $bg: "../assets/img/ko/clip_menu.png",
            $position: 0 -93px
          );
          content: "";
          opacity: 0;
          transition: 0.3s;
        }
        &:nth-child(2) {
          background-position-x: -208px;
          &:after {
            background-position-x: -208px;
          }
        }
        &:nth-child(3) {
          background-position-x: -416px;
          &:after {
            background-position-x: -416px;
          }
        }
        &:nth-child(4) {
          background-position-x: -624px;
          &:after {
            background-position-x: -624px;
          }
        }
        &:nth-child(5) {
          background-position-x: -836px;
          &:after {
            background-position-x: -836px;
          }
        }

        &:hover,
        &.router-link-exact-active {
          &:after {
            opacity: 1;
            transition: 0.3s;
          }
        }
        .en & {
          height: 99px;
          background-image: url("../assets/img/en/clip_menu_en.png");
          &:after {
            background-image: url("../assets/img/en/clip_menu_en.png");
            background-position-y: -99px;
          }
        }
        .ja & {
          background-image: url("../assets/img/ja/clip_menu_ja.png");
          &:after {
            background-image: url("../assets/img/ja/clip_menu_ja.png");
          }
        }
        .zh & {
          background-image: url("../assets/img/zh/clip_menu_zh.png");
          &:after {
            background-image: url("../assets/img/zh/clip_menu_zh.png");
          }
        }
      }
    }
  }

  @include bp(tablet) {
    &__bg {
      min-height: auto;
      &-view {
        video {
          height: 100%;
        }
      }
    }
    &__contents {
      height: 150px;
      top: 18%;
    }
  }
  @media (max-width: 960px) and (min-aspect-ratio: 1920/1080) {
    &__bg {
      &-view {
        video {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
